import { render, staticRenderFns } from "./campaigns-editbale-status.vue?vue&type=template&id=ce790c8e&"
import script from "./campaigns-editbale-status.vue?vue&type=script&lang=js&"
export * from "./campaigns-editbale-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports